<h2 class="mb-5">{{ 'COMMON.TESTS' | translate }}</h2>
<div class="card mb-4 border-0 shadow-sm">
  <div class="card-header bg-white pt-4 border-bottom-0">
    <h5>{{ 'CANDIDATES.SEARCHFILTERS' | translate }}</h5>
  </div>

  <div class="card-body">
    <form [formGroup]="invitationSearchForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-group col-md-2">
          <label for="randstadCandidate">{{ 'COMMON.CANDIDATEID' | translate }}</label>
          <input type="text" class="form-control" id="randstadCandidate" formControlName="randstadCandidate"
            maxlength="15">
          <ct-control-messages [control]="invitationSearchForm.get('randstadCandidate')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="email">{{ 'COMMON.EMAIL' | translate }}</label>
          <input type="email" class="form-control" id="email" formControlName="email">
          <ct-control-messages [control]="invitationSearchForm.get('email')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="idCard">{{ 'COMMON.DOCUMENT' | translate }}</label>
          <input type="text" class="form-control" id="idCard" formControlName="idCard" maxlength="10">
          <ct-control-messages [control]="invitationSearchForm.get('idCard')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="name">{{ 'COMMON.NAME' | translate }}</label>
          <input type="text" class="form-control" id="name" formControlName="name">
          <ct-control-messages [control]="invitationSearchForm.get('name')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="surname">{{ 'COMMON.SURNAME' | translate }}</label>
          <input type="text" class="form-control" id="surname" formControlName="surname">
          <ct-control-messages [control]="invitationSearchForm.get('surname')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2">
          <label for="periods">{{ 'COMMON.SEARCHPERIOD' | translate }}</label>
          <select class="form-control" id="periods" formControlName="period" (change)="checkPeriod(this)">
            <option *ngFor="let period of periods" [ngValue]="period.value">{{ 'SEARCHPERIOD.'+period.key | translate }}
            </option>
            <option [ngValue]="null">{{ 'COMMON.ALL' | translate }}</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-1">
          <label for="invitationId">{{'COMMON.INVITATIONID' | translate}}</label>
          <input type="text" class="form-control" id="invitationId" formControlName="invitationId" maxlength="10">
          <ct-control-messages [control]="invitationSearchForm.get('invitationId')"></ct-control-messages>
        </div>
        <div class="form-group col-md-1">
          <label for="testId">{{'COMMON.TESTID' | translate}}</label>
          <input type="text" class="form-control" id="testId" formControlName="testId" maxlength="10">
          <ct-control-messages [control]="invitationSearchForm.get('testId')"></ct-control-messages>
        </div>

        <div class="form-group col-md-2" *ngIf="viewInit">
          <label for="process">{{ 'COMMON.PROCESS' | translate }}</label>
          <ng-select [items]="processes" [multiple]="true" bindLabel="name" bindValue="id" [groupBy]="groupByFn"
            [selectableGroup]="true" [closeOnSelect]="false" labelForId="process" formControlName="process"
            placeholder="{{ 'COMMON.SELECT' | translate }}" notFoundText="{{ 'CANDIDATES.NORESULTS' | translate }}"
          >
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [checked]="item$.selected"/> {{ 'COMMON.ALL' | translate }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [checked]="item$.selected"/> {{ item.name | titlecase }}
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items | slice:0:1">
                <span class="ng-value-label">{{ item.name | titlecase }}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{ items.length - 1 }} {{ 'COMMON.MORE' | translate }}...</span>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <div class="col-md-2" (clickOutside)="toogleStatusList('close')">
          <div class="form-group"><label for="status">{{ 'COMMON.STATUS' | translate }}</label>
            <div class="statusSelect">
              <div class="statusSelected" (click)="toogleStatusList('')">
                <!-- <span class="caret"> </span> -->
                <!-- si todos están deseleccionados marcamos todos -->
                <div *ngIf="allUnselect" class="statusAllUnselect">{{ 'COMMON.ALL' | translate }}</div>
                <ul *ngIf="!allUnselect">
                  <li *ngFor="let item of itemStatus">
                    <div *ngIf="item.selected" class="dot mr-1" [ngClass]="item.color"></div>
                  </li>
                  <i class="float-right font-weight-bold fa fa-angle-down"></i>
                </ul>
              </div>
              <div class="statusList" [ngClass]="{'status-list-hide': statusListHide}">
                <ul>
                  <li *ngFor="let item of itemStatus" (click)="statusSelected(item)">
                    <div>
                      <span [ngClass]="{'checkbox-unchecked':!item.selected,'checkbox-checked':item.selected}"
                        class="checkbox-checked"></span>
                    </div>
                    <div class="dot mr-1" [ngClass]="item.color"></div>
                    <div [ngClass]="{'status_selected': item.selected }">
                      {{ 'STATUS.' + item.status.toLocaleUpperCase() | translate }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group col-md-2">
          <label for="jobtype">{{ 'COMMON.JOBTYPE' | translate }}</label>
          <select class="form-control" id="jobtype" formControlName="jobtype">
            <option [ngValue]="null" hidden selected>{{ 'INVITE.SELECTJOBTYPE' | translate }}</option>
            <option [ngValue]="null">{{ 'COMMON.ALL' | translate }}</option>
            <option *ngFor="let jobtype of jobtypes" [ngValue]="jobtype.id">{{ jobtype.name | titlecase }}
            </option>
          </select>
        </div>

        <div class="form-group col-md-2" *ngIf="viewInit">
          <label for="testModel">{{ 'COMMON.TESTMODEL' | translate }}</label>
          <ng-select [items]="testModels" [multiple]="true" bindLabel="name" bindValue="id" [groupBy]="groupByFn"
            [selectableGroup]="true" [closeOnSelect]="false" labelForId="testModel" formControlName="testModel"
            placeholder="{{ 'COMMON.SELECT' | translate }}" notFoundText="{{ 'CANDIDATES.NORESULTS' | translate }}"
          >
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [checked]="item$.selected"/> {{ 'COMMON.ALL' | translate }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{ index }}" type="checkbox" [checked]="item$.selected"/> {{ item.name | titlecase }}
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items | slice:0:1">
                <span class="ng-value-label">{{ item.name | titlecase }}</span>
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              </div>
              <div class="ng-value" *ngIf="items.length > 1">
                <span class="ng-value-label">{{ items.length - 1 }} {{ 'COMMON.MORE' | translate }}...</span>
              </div>
              <!-- <span style="display:block" class="ng-placeholder">{{ 'COMMON.SELECT' | translate }}</span> -->
            </ng-template>
          </ng-select>
        </div>

        <div class="form-group col-md-2">
          <label>&nbsp;</label>
          <select class="form-control" id="createdBy" formControlName="createdBy">
            <option value="">{{ 'COMMON.ALL' | translate }}</option>
            <option value="office">{{ 'CONSULTANT.SENDBYMYOFFICE' | translate }}</option>
            <option value="consultant">{{ 'CONSULTANT.MYTESTS' | translate }}</option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-8"></div>
        <div class="form-group col-md-2">
          <button type="button" class="btn btn-light form-control" (click)="deleteFilters()">
            <i class="fa fa-filter"></i> {{ 'CANDIDATES.DELETEFILTERS' | translate }}
          </button>
        </div>
        <div class="form-group col-md-2">
          <button type="submit" class="btn btn-primary form-control" [disabled]="invitationSearchForm.invalid">
            <i class="fa fa-search"></i> {{ 'COMMON.SEARCH' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<ct-datatable [items$]="invitations$" class="datatable" (reload)="searchInvitations($event.page)" id="testSearchTable">
  <thead>
    <tr>
      <th colspan="3" id="results">{{ 'CANDIDATES.ALLRESULTS' | translate }}
        ({{ (invitations$ | async)?.total || 0 }})</th>
      <th [colSpan]="showActions ? 8 : 10"></th>
      <th colspan="2" id="actions" *ngIf="showActions">
        <div ngbDropdown placement="bottom-right">
          <div ngbDropdownToggle> {{ 'CANDIDATES.ACTIONS' | translate }}</div>
          <div ngbDropdownMenu>
            <button ngbDropdownItem (click)="exportModal('reports')">{{ 'EXPORT.REPORTS.TITLE' | translate }}</button>
            <button ngbDropdownItem *ngIf="canExportScores" (click)="exportModal('scores')">{{ 'EXPORT.SCORES.TITLE' | translate }}</button>
            <button ngbDropdownItem (click)="exportModal('massiveSend')">{{ 'EXPORT.MASSIVESEND.TITLE' | translate }}</button>
          </div>
        </div>
      </th>
    </tr>
  </thead>
  <thead>
    <tr>
      <th>{{ 'COMMON.CANDIDATEID' | translate }}</th>
      <th>{{ 'COMMON.INVITATIONID' | translate }}</th>
      <th>{{ 'COMMON.TESTID' | translate }}</th>
      <th>{{ 'COMMON.NAME' | translate }}</th>
      <th>{{ 'COMMON.EMAIL' | translate }}</th>
      <th>{{ 'COMMON.DNI' | translate }}</th>
      <th>{{ 'COMMON.RANDSTAD' | translate }}</th>
      <th>{{ 'COMMON.PROCESS' | translate }}</th>
      <th>{{ 'COMMON.TEST' | translate }}</th>
      <th>{{ 'COMMON.DATE' | translate }}</th>
      <th>{{ 'COMMON.HISTORIC' | translate }}</th>
      <th class="text-center">{{ 'STATUS.LABEL' | translate }}</th>
      <th class="text-center">{{ 'CANDIDATES.ACTIONS' | translate }}</th>
    </tr>
  </thead>

  <tbody class="bg-white">
    <ng-container *ngFor="let invitation of (invitations$ | async)?.data">
      <tr *ngFor="let test of (invitation)?.tests">
        <td>{{ invitation.candidate.randstadCandidate }}</td>
        <td>{{ invitation.id ? invitation.id : '-' }}</td>
        <td>{{ test.id }}</td>
        <td [ngbTooltip]="(invitation.candidate.name || '') + ' ' + (invitation.candidate.surnameComplete || '') | titlecase"
          container="body" [disableTooltip]="invitation.candidate.name? false : true">
          {{ (invitation.candidate.name || '') + ' ' + (invitation.candidate.surnameComplete || '') | titlecase }}
        </td>
        <td [ngbTooltip]="invitation.candidate.email" container="body">{{ invitation.candidate.email }}</td>
        <td>{{ invitation.candidate.idCard }}</td>
        <td>
          <img *ngIf="invitation.candidate.origin === 'web'" src="/assets/images/randstad-icon.png" alt="Randstad"
            class="randstad-icon">
        </td>
        <td [ngbTooltip]="invitation.group?.name | titlecase" container="body">{{ invitation.group?.name | titlecase }}
        </td>
        <td [ngbTooltip]="utilsService.getTestName(test, invitation)" container="body">
          {{ utilsService.getTestName(test, invitation) }}
        </td>
        <td>{{ invitation.createdAt | dateformat }}</td>
        <td><i *ngIf="invitation.id !== 0" class="fa fa-list-alt" (click)="openHistory(invitation.candidate)"
            [ngbTooltip]="'TOOLTIP.HISTORIC' | translate"></i></td>
        <td class="text-center">
          <span *ngIf="test.status.toUpperCase() === 'PENDING'" class="dot orange center"
            title="{{ 'STATUS.'+test.status.toUpperCase() | translate }}"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="test.status.toUpperCase() === 'ACTIVE'" class="dot green center"
            title="{{ 'STATUS.'+test.status.toUpperCase() | translate }}"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="test.status.toUpperCase() === 'EXPIRED'" class="dot red center"
            title="{{ 'STATUS.'+test.status.toUpperCase() | translate }}"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
          <span *ngIf="(test.status.toUpperCase() === 'COMPLETED')"
            class="dot blue center" title="{{ 'STATUS.'+test.status.toUpperCase() | translate }}"
            [ngbTooltip]="'STATUS.'+test.status.toUpperCase() | translate">&nbsp;</span>
        </td>
        <!-- <td>{{ test.result.completionPercentage+'%' }}</td> -->
        <td class="text-center">
          <i class="fa fa-file mx-1"
            *ngIf="(test.status.toUpperCase() === 'COMPLETED') && utilsService.ADNTestModelIds.includes(test.testModelId)"
            [ngbTooltip]="'TOOLTIP.REPORTS' | translate"
            [routerLink]="'/consultant/reports/invitation/' + invitation.id + '/test/' + test.id"
            (click)="utilsService.setLastUrl()">
          </i>
          <i class="fa fa-file mx-1"
            *ngIf="(test.status.toUpperCase() === 'COMPLETED') && test.testModel.origin === 'ct' && !utilsService.ADNTestModelIds.includes(test.testModelId)"
            [ngbTooltip]="'TOOLTIP.REPORTS' | translate"
            [routerLink]="'/consultant/reports-ct/invitation/' + invitation.id + '/test/' + test.id"
            (click)="utilsService.setLastUrl()">
          </i>
          <a class="fa fa-file mx-1"
            *ngIf="(test.status.toUpperCase() === 'COMPLETED') && test.testModel.origin === 'evalualia'"
            [ngbTooltip]="'TOOLTIP.REPORT' | translate"
            (click)="getEvalualiaReport(test.id, invitation.candidate.randstadCandidate, invitation.id, invitation.officeId)">
          </a>

          <i class="fa fa-bell mx-1"
            *ngIf="(test.status.toUpperCase() === 'PENDING' || test.status.toUpperCase() === 'ACTIVE') && invitation.id !== 0"
            (click)="sendReminder(invitation)" [ngbTooltip]="'TOOLTIP.SENDREMINDER' | translate">
          </i>
          <ng-container
            *ngIf="HCC.includes(invitation.office?.randstadOffice) && HCC.includes(consultant.office.randstadOffice) && invitation.token">

            <i *ngIf="(test.status.toUpperCase() === 'PENDING' || test.status.toUpperCase() === 'ACTIVE')"
              class="fa fa-link mx-1" (click)="copyCandidateHomeLink(invitation?.token)"
              [ngbTooltip]="'TOOLTIP.COPY'  | translate">
            </i>
          </ng-container>

        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!(invitations$ | async)?.data.length">
      <td colspan="13" class="text-center">{{ 'CANDIDATES.NORESULTS' | translate }}</td>
    </tr>
  </tbody>
</ct-datatable>


<ct-export-reports *ngIf="(invitations$ | async)?.data.length"></ct-export-reports>
<ct-export-scores *ngIf="(invitations$ | async)?.data.length"></ct-export-scores>
<ct-massive-send *ngIf="(invitations$ | async)?.data.length"></ct-massive-send>
